// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingButton_spinner__MogaR"};